module.exports = __webpack_public_path__ + "static/media/5_3.2923b8bb.png";